// 科室数据
import axios from '@/http/index'

// 获取所有期刊
export const getDept = (data) => {
    return axios({
        method: 'POST',
        url: '/api/rag/getdept',
		data,
    })
}

// 添加关键词
export const addKeyword = (data) => {
    return axios({
        method: 'POST',
        url: '/api/rag/add_keyword',
		data,
    })
}

// 获取引用
export const getReference = (data) => {
    return axios({
        method: 'POST',
        url: '/api/rag/get_search_result',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 检索列表
export const getRagSearchList = (data) => {
    return axios({
        method: 'POST',
        url: '/api/rag/search_list',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取历史消息
export const getHistorysearch = (data) => {
    return axios({
        method: 'POST',
        url: '/api/rag/search_msg',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 删除检索
export const delSearch_rag = (data) => {
    return axios({
        method: 'POST',
        url: '/api/rag/search_del',
		data,
		requestLoading: true,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取全文
export const getRagScihub = (data) => {
    return axios({
        method: 'POST',
        url: '/api/rag/get_scihub',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取全文总结的历史记录
export const getAskHistory = (data) => {
    return axios({
        method: 'POST',
        url: '/api/ask_history',
		data,
    })
}

// 获取全文总结的思维导图
export const getAskEcharts = (params) => {
    return axios({
        method: 'GET',
        url: '/api/ask_echarts',
		params
    })
}

// 获取回答和文献
export const checkRefererData = (params) => {
    return axios({
        method: 'POST',
        url: '/api/rag/check_referer',
		params,
    })
}


// 获取
export const getDocuments = (params) => {
    return axios({
        method: 'GET',
        url: '/api/rag/get_documents',
		params
    })
}
